<div class="row">
  <div class="col-md-6">
    <tree-editor #treeEditor1 [avaialbleTreeEditorNodes]="availableData"></tree-editor>
  </div>
  <div class="col-md-6">
    <div class="row" *ngFor="let selection of treeEditor1.getSelectedValues()">
      <div class="col-md-4">{{selection.item}}</div>
      <div class="col-md-4">{{selection.value}}</div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-2">
    <button (click)="copySelection()">Copy Selection</button>
  </div>
  <div class="col-md-2">
    <button (click)="changeDataSource()">Change Data Source</button>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <tree-editor #treeEditor2 [avaialbleTreeEditorNodes]="availableData"></tree-editor>
  </div>
  <div class="col-md-6">
    <div class="row" *ngFor="let selection of treeEditor2.getSelectedValues()">
      <div class="col-md-4">{{selection.item}}</div>
      <div class="col-md-4">{{selection.value}}</div>
    </div>
  </div>
</div>
